export class StoredPreferences {
  constructor(
    public volume: number,
    public isSubtitlesDisplayed: boolean,
    public subtitlesLanguage: string,
    public isDebugModeOpen: boolean,
  ) {}
}
